const Checkbox = ({
  label,
  onClick,
  choosenValues,
  value
}: {
  label: string;
  onClick: (gender: string) => void;
  choosenValues: string[];
  value: string;
}) => {
  return (
    <label className="flex items-center">
      <input
        type="checkbox"
        className="hidden"
        onChange={(e) => {
          onClick(e.target.value);
        }}
        checked={choosenValues.includes(value)}
        value={value}
      />
      <svg
        className="w-4 h-4 inline mr-2"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          rx="3.5"
          fill="#FCF5FF"
          className={`${choosenValues.includes(value) ? 'visible' : 'hidden'}`}
        />
        <path
          d="M12 5L6.5 10.5L4 8"
          stroke="#C34DFF"
          strokeWidth="1.6666"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`${choosenValues.includes(value) ? 'visible' : 'hidden'}`}
        />
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          rx="3.5"
          stroke="#D4D4D4"
          fill={`${choosenValues.includes(value) ? 'none' : '#fff'}`}
        />
      </svg>
      <span className="text-sm whitespace-nowrap dark:text-white">{label}</span>
    </label>
  );
};

export default Checkbox;
